<template>
  <div>
    <ui-heading tag="h5">
      {{ $t("companyProcedures.comment.title") }}
    </ui-heading>
    <div v-if="comment && comment.length">
      <p class="user-comment">{{ comment }}</p>
    </div>
    <div v-else>-</div>
  </div>
</template>
<script>
export default {
  props: {
    comment: { type: String, default: null }
  }
};
</script>
<style scoped>
.user-comment {
  white-space: pre-wrap;
}
</style>
